import { translate, translationKeys } from 'logic/translations/translations.service';
import { isSortOffersBy, SortOffersBy } from 'logic/api-models/sort-offer-by';

export const getSortingOptions = (shouldSortByDistance: boolean) =>
  [
    SortOffersBy.Default,
    SortOffersBy.Rating,
    SortOffersBy.HighestPrice,
    SortOffersBy.LowestPrice,
    SortOffersBy.Newest,
    shouldSortByDistance ? SortOffersBy.Distance : undefined,
  ]
    .filter(isSortOffersBy)
    .map((sortBy) => ({
      value: sortBy,
      label: translate(translationKeys.search.sortDropdown.options[sortBy]),
    }));
